import React from "react";
import { CloudSun, Moon, Sun, X } from "lucide-react";
import { useBackToCloseModal } from "../../../../hooks/useBackToCloseModal";
import { BandAvailabilityDto } from "@/src/web-api-client";

//MOBILE
interface Props {
  setShowBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  showBottomSheet: boolean;
  morningSlots: BandAvailabilityDto[];
  afternoonSlots: BandAvailabilityDto[];
  selectedTime: BandAvailabilityDto;
  handleTimeSelect: (time: BandAvailabilityDto) => void;
}

const TimeSlot = ({
  setShowBottomSheet,
  showBottomSheet,
  morningSlots,
  afternoonSlots,
  selectedTime,
  handleTimeSelect,
}: Props) => {
  useBackToCloseModal(
    showBottomSheet,
    () => setShowBottomSheet(false),
    "time-modal"
  );

  return (
    <div>
      {/* Content */}
      <div className="py-4 px-3 overflow-y-auto max-h-[70vh]">
        {morningSlots.length > 0 && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mt-2 mb-3">
              <Sun className="w-6 h-6 fill-current text-yellow-500 " />
              <span className="md:text-lg font-semibold text-gray-800">
                Buổi sáng
              </span>
            </div>
            <div className="flex gap-3">
              {morningSlots.map((time: BandAvailabilityDto, idx) => (
                <button
                  key={idx}
                  onClick={() => handleTimeSelect(time)}
                  className={`max-w-[140px] min-w-[140px] md:text-base text-sm p-2 md:py-4 py-3 rounded-lg border-2 font-medium transition-all duration-200 
                    ${
                      selectedTime === time
                        ? "color-primary text-white border-green-500"
                        : "bg-white text-gray-700 border-green-300 hover:border-green-600"
                    }`}
                >
                  <span>{time.range}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {afternoonSlots.length > 0 && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mt-2  mb-3">
              <Moon className="w-6 h-6 fill-current text-blue-300" />
              <span className="md:text-lg font-semibold text-gray-800">
                Buổi chiều
              </span>
            </div>
            <div className="flex gap-3">
              {afternoonSlots.map((time: BandAvailabilityDto, idx) => (
                <button
                  key={idx}
                  onClick={() => handleTimeSelect(time)}
                  className={`max-w-[140px] min-w-[140px] md:text-base text-sm p-2 md:py-4 py-3 rounded-lg border-2 font-medium transition-all duration-200 
                    ${
                      selectedTime === time
                        ? "color-primary text-white border-green-500"
                        : "bg-white text-gray-700 border-green-300 hover:border-green-500"
                    }`}
                >
                  <span>{time.range}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeSlot;
